import React, {useContext} from 'react';
import HelperGoogleAnalytics4 from '../../../common/helpers/HelperGoogleAnalytics4';
import Price from '../../../common/primitives/Price';
import ComponentSearchDomainForm from '../../../components/ComponentSearchDomainForm/ComponentSearchDomainForm';
import {ContextServicePrice} from '../../../context/ContextServicePriceProvider';
import styles from './DomainSearch.scss'
import Banners from "../Banners/Banners";

const FeaturedTLDS = () => {
	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const comPrice = context.getVOForIdAndTerm('com', 12);
	const bgPrice = context.getVOForIdAndTerm('bg', 12);
	const euPrice = context.getVOForIdAndTerm('eu', 12);

	return <div className={styles.featuredTLDS}>

		<div className={styles.tldContainer}>
			<div className={styles.tld}>
				.COM
			</div>
			<div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={comPrice.currency} value={comPrice.priceNew}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={comPrice.currency} value={comPrice.basePriceNew}/>
                </span>
			</div>
			{SHVO.showEuroPrices && <div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={comPrice.currencyEUR} value={comPrice.priceNewEUR}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={comPrice.currencyEUR} value={comPrice.basePriceNewEUR}/>
                </span>
			</div>}
		</div>


		<div className={styles.tldContainer}>
			<div className={styles.tld}>
				.BG
			</div>
			<div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={bgPrice.currency} value={bgPrice.priceNew}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={bgPrice.currency} value={bgPrice.basePriceNew}/>
                </span>
			</div>
			{SHVO.showEuroPrices && <div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={bgPrice.currencyEUR} value={bgPrice.priceNewEUR}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={bgPrice.currencyEUR} value={bgPrice.basePriceNewEUR}/>
                </span>
			</div>}
		</div>


		<div className={styles.tldContainer}>
			<div className={styles.tld}>
				.EU
			</div>
			<div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={euPrice.currency} value={euPrice.priceNew}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={euPrice.currency} value={euPrice.basePriceNew}/>
                </span>
			</div>
			{SHVO.showEuroPrices && <div className={styles.price}>
                <span className={styles.newPrice}>
                    <Price currency={euPrice.currencyEUR} value={euPrice.priceNewEUR}/>
                </span>
				<span className={styles.oldPrice}>
                    <Price currency={euPrice.currencyEUR} value={euPrice.basePriceNewEUR}/>
                </span>
			</div>}
		</div>

	</div>
}

export default function DomainSearch() {
	/** @type {ContextServicePriceProvider} */
	const context = useContext(ContextServicePrice);
	const comPrice = context.getVOForIdAndTerm('com', 12);
	const euPrice = context.getVOForIdAndTerm('eu', 12);

	return (
	  <div className={styles.container}>
		  {/*<div*/}
		  {/*className={`${styles.containerEUImg} ${euPrice.currency !== 'BGN' ? styles.containerEUImg_en : ''}`}></div>*/}
		  <div className={styles.featured}>
			  <div>
				  <div className={styles.domainFormContainer}>
					  <ComponentSearchDomainForm customGA4Event={() => {
						  HelperGoogleAnalytics4.TrackEvent('HomePage Events', 'Domain Selector-Search Domain', 'Homepage-up');
					  }}/>
				  </div>
			  </div>
			  <div>
				  <FeaturedTLDS/>
			  </div>
		  </div>

		  <Banners currency={comPrice.currency} comPrice={comPrice.priceNew}/>
	  </div>
	)
}
